
import { defineComponent, computed } from '@vue/composition-api';
import { Actions } from '@/shared/store/actionsTypes';
import { FCButton } from '@fc/angie-ui';
import { ICartProducts } from '~/store/types';

export default defineComponent({
  name: 'CartSubItemShopify',
  emits: ['removeFromCart'],
  components: {
    FCButton,
  },
  props: {
    freeMembershipMonths: {
      type: Boolean,
      default: false,
    },
    isDrawer: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // @ts-expect-error
    const { $store } = useNuxtApp();
    const productName = computed(() => {
      const annualProductIds = [
        'gid://shopify/Product/7881444556889', // dev
        'gid://shopify/Product/8727723376876', // prod
      ];
      const hasAnnualUpgradeBundle = computed(() => ($store.getters.cartProducts as ICartProducts).shopifyItems.find(item => annualProductIds.includes(item.id)));
      if (hasAnnualUpgradeBundle.value) {
        return 'Membership (1 Year @ $33.33/mo)';
      }
      return $store.getters.membershipInCart.title;
    });

    const subscription = computed(() => {
      const isSubPriceVariant = $store.getters.isExp_035_subPriceVariant;
      // eslint-disable-next-line no-nested-ternary
      const price = $store.getters.membershipInCart.variants[0].price === 0 && isSubPriceVariant
        ? 4400
        : $store.getters.membershipInCart.variants[0].price > 0
          ? null
          : 3900;

      return {
        id: $store.getters.membershipInCart.variants[0].id,
        price,
        pricingDescription: $store.getters.membershipInCart.description,
        product: {},
        productName: productName.value,
        qty: 1,
        subid: $store.getters.membershipInCart.metadata.stripeSubId,
        type: $store.getters.membershipInCart.productType,
      };
    });

    return {
      openMembershipModal: () => { $store.dispatch(Actions.OPEN_MODAL, { component: 'membership' }); },
      subscription,
      enableRemove: computed(() => (!$store.getters.cartProducts.packageInCart && !$store.getters.isGen2UpgradeInCart) && $store.getters.currentRoute.name !== 'shop-checkout'),
    };
  },
});

